import styled from "styled-components";

export const Box = styled.div`
  background: #0e1714;
  border: 1px solid rgba(212, 175, 55, 0.18);
  border-radius: 16px;
  overflow: hidden;
`;
